module.exports = __webpack_public_path__ + "static/media/11NEPAD6.64f016ff.jpg";